module.exports = __webpack_public_path__ + "img/ner_tagger_highlight.e1d131e3.svg";